<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app class="fill-height" style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row  class="m-0 mb-1 elevation-1" style="max-height: 4rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 4rem; padding-left: 12px">
            <v-text-field
                v-model="definition.api_name"
                :rules="[rules.required]"
                label="Schnittstellenname"
                style="max-width: 400px !important;"
                hide-details
            ></v-text-field>
            <div class="t-btn-left"></div>
            <v-btn
                block
                color="success"
                class="white--text t-btn"
                @click="getTestData"
            >
              <v-icon left>
                mdi-test-tube
              </v-icon>
              Testen
            </v-btn>
            <v-btn
                block
                color="success"
                class="white--text t-btn"
                @click="$refs['definition-settings-dialog'].show()"
            >
              <v-icon left>
                mdi-cog
              </v-icon>
              Einstellungen
            </v-btn>
            <v-btn
                block
                color="error"
                class="white--text t-btn"
                @click="onDelete"
                v-if="definition.id !== 'new'"
            >
              <v-icon left>
                mdi-delete-circle
              </v-icon>
              Löschen
            </v-btn>
            <v-btn
                block
                color="success"
                class="white--text t-btn"
                :disabled="definition.api_name === ''"
                @click="onSave"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              {{definition.id === 'new' ? 'Anlegen' : 'Speichern'}}
            </v-btn>
            <v-btn
                block
                color="blue"
                class="white--text t-btn"
                @click="$router.go(-1)"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              Zurück
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
          :headers="headers"
          :items="entries"
          disable-sort
          class="elevation-1 sortable-table"
          item-key="id"
          fixed-header
          disable-pagination
          hide-default-footer
          height="100%"
      >
        <template v-slot:top>
          <v-toolbar
              flat
          >
            <v-toolbar-title>Schnittstellendefinition</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                class="mb-2"
                @click="editEntry({entry: undefined, defaults: undefined})"
            >
              Neuer Eintrag
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.drag`]="{ item }">
          <v-icon class="drag-handle" style="cursor: grab;">
            mdi-drag-horizontal
          </v-icon>
        </template>
        <template v-slot:item.entry.data_type="{ item }">
          {{dataTypeToText(item.entry.data_type)}}
        </template>
        <template v-slot:item.entry.format="{ item }">
          {{formatToText(item.entry)}}
        </template>
        <template v-slot:item.entry.content="{ item }">
          {{contentToText(item.entry)}}
        </template>
        <template v-slot:item.entry.an="{ item }">
          {{entryToText(item, 'assumption')}}
        </template>
        <template v-slot:item.entry.au="{ item }">
          {{entryToText(item, 'payout')}}
        </template>
        <template v-slot:item.entry.ex="{ item }">
          {{entryToText(item, 'extern')}}
        </template>
        <template v-slot:item.entry.ei="{ item }">
          {{entryToText(item, 'eigen')}}
        </template>
        <template v-slot:item.entry.st="{ item }">
          {{entryToText(item, 'storno')}}
        </template>
        <template v-slot:item.entry.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editEntry(item)"
              color="green"
          >
            mdi-pencil
          </v-icon>
          <v-icon
              small
              @click="deleteEntry(item.entry)"
              color="red"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    <definition-settings-dialog @submit="changeDefinition" :definition="definition" ref="definition-settings-dialog"></definition-settings-dialog>
    <top-level-dialog @submit="changeEntry" :konto_setting="konto_settings" :entry-prop="currentEntry" :defaults="currentDefaults" ref="entry-dialog"></top-level-dialog>
    </div>
    <v-dialog
        v-model="showTestDialog"
        scrollable
        max-width="500px"
    >
      <v-card>
        <v-card-title>Auftrag wählen</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">
          <v-text-field
              label="Suche"
              v-model="taskSearch"
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          <v-radio-group
              v-model="selectedTask"
              column
          >
            <v-radio v-for="task in filteredTask"
                     :key="task.id"
                :label="task.object + ' (' + task.aufisn + ')'"
                :value="task.id"
            ></v-radio>

          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="showTestDialog = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="!selectedTask"
              @click="generateTestFile(selectedTask); showTestDialog = false"
          >
            Datei generieren
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>


<script>

import DefinitionSettingsDialog  from "./DefinitionSettingsDialog.vue";
import TopLevelDialog  from "./TopLevelEntryDialog.vue";
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {v4, v4 as uuidv4} from 'uuid';
import Sortable from "sortablejs";

export default {
  name: "definition",
  components: {
    DefinitionSettingsDialog: DefinitionSettingsDialog,
    TopLevelDialog: TopLevelDialog,
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Muss gesetzt sein.',
    },
    currentEntry: undefined,
    currentDefaults: undefined,
    definition: {
      id: "new",
      api_name: "",
      format: "fixed_length",
      delimiter: "",
      template_file: "",
      fixed_filename: "",
      use_field_names: false,
      use_overwrite: false,
      combine_assumption_payout: true,
      only_assumption: false,
      only_assumption_extern: false,
      only_payout: false,
      use_details: false,
      skip_cancellation: false,
      use_lead_in_line: false,
      lead_in_line: "",
    },
    entries: [],
    headers: [
      { text: "", value: "drag", sortable: false, width: "50px" },
      {
        text: 'Titel',
        align: 'start',
        value: 'entry.title',
      },
      { text: 'Typ', align: 'start', value: 'entry.data_type' },
      { text: 'Format', align: 'start', value: 'entry.format' },
      { text: 'Inhalt', align: 'start', value: 'entry.content' },
      { text: 'Länge', align: 'start', value: 'entry.field_length' },
      { text: 'Def. Annahme', align: 'start', value: 'entry.an' },
      { text: 'Def. Auszahlung', align: 'start', value: 'entry.au' },
      { text: 'Def. Extern', align: 'start', value: 'entry.ex' },
      { text: 'Def. Eigen', align: 'start', value: 'entry.ei' },
      { text: 'Def. Storno', align: 'start', value: 'entry.st' },
      { text: 'Aktionen', value: 'entry.actions' },
    ],
    konto_settings: [],


    // display only
    contentTypes: {
      "string": [
        {text: 'Rechnungsnummer', value: "ab_invoice.invoice_number"},
        {text: 'Konto-Einnahme', value: "ab_invoice.hh_ein"},
        {text: 'Konto-Einnahme-Text', value: "ab_invoice.hh_ein_txt"},
        {text: 'Konto-Ausgabe', value: "ab_invoice.hh_aus"},
        {text: 'Konto-Ausgabe-Text', value: "ab_invoice.hh_aus_txt"},

        {text: 'Auftragsnummer', value: "bd_auftrag.aufisn"},
        {text: 'Unterauftragsnummer', value: "bd_auftrag.pos_nr"},
        {text: 'Auftrag-Wo', value: "bd_auftrag.object"},
        {text: 'Auftrag-Was', value: "bd_auftrag.task"},
        {text: 'Auftrag-Inter/Extern', value: "bd_auftrag.task_type_1"},
        {text: 'Auftragsart', value: "bd_auftrag.art_auf"},
        {text: 'Sachbearbeiter', value: "bd_auftrag.clerk"},
        {text: 'Sachbearbeiter-Telefon', value: "bd_auftrag.clerk_tel"},
        {text: 'Auftrag-Memo', value: "bd_auftrag.memo"},
        {text: 'Auftraggeber-Anrede', value: "bd_auftrag.salutation"},
        {text: "Auftraggeber-Name1", value: "bd_auftrag.name_1"},
        {text: "Auftraggeber-Name2", value: "bd_auftrag.name_2"},
        {text: "Auftraggeber-Straße", value: "bd_auftrag.street"},
        {text: "Auftraggeber-Plz", value: "bd_auftrag.zip_code"},
        {text: "Auftraggeber-Ort", value: "bd_auftrag.city"},
        {text: "Auftrag-Belegnr-Extern", value: "bd_auftrag.beleg_ex"},
        {text: "Auftrag-Abrechnungs-Kenz.", value: "bd_auftrag.nkr_kasse"},
        {text: "Rechnung-Anrede", value: "bd_auftrag.re_anrede"},
        {text: "Rechnung-Name", value: "bd_auftrag.re_vorname"},
        {text: "Rechnung-Zu-Händen", value: "bd_auftrag.re_name_1"},
        {text: "Rechnung-Straße", value: "bd_auftrag.re_strh_nr"},
        {text: "Rechnung-Land", value: "bd_auftrag.re_land"},
        {text: "Rechnung-Plz", value: "bd_auftrag.re_plz"},
        {text: "Rechnung-Ort", value: "bd_auftrag.re_ort"},
        {text: "Rechnung-PK-Nummer", value: "bd_auftrag.re_nr"},
      ],
      "float": [{text: 'Rechnungspreis', value: "ab_invoice.price"}],
      "float_negative": [{text: 'Rechnungspreis', value: "ab_invoice.price"}],
      "integer": [{text: 'Rechnungspreis', value: "ab_invoice.price"},  {text: "Auftrag-MWST-Prozent", value: "bd_auftrag.mwst_percentage"},],
      "integer_negative": [{text: 'Rechnungspreis', value: "ab_invoice.price"},  {text: "Auftrag-MWST-Prozent", value: "bd_auftrag.mwst_percentage"},],
      "date": [{text: 'Rechnungsdatum', value: "ab_invoice.create_date"}, {text: "aktuelles Datum", value: "now()"}],
    },
    dataTypes: [
      {text: 'Text', value: "string"},
      {text: 'Ganzahl (positiv)', value: "integer"},
      {text: 'Ganzahl (negativ)', value: "integer_negative"},
      {text: 'Dezimalzal (positiv)', value: "float"},
      {text: 'Dezimalzal (negativ)', value: "float_negative"},
      {text: 'Datum', value: "date"},
      {text: 'Wahrheitswert', value: "boolean"},
      {text: 'Festwert', value: "fixed"},
    ],
    formats: {
      "float": [{text: 'Komma-Getrennt', value: "float_comma"}, {text: 'Punkt-Getrennt', value: "float_dot"}],
      "float_negative": [{text: 'Komma-Getrennt', value: "float_comma"}, {text: 'Punkt-Getrennt', value: "float_dot"}],
      "integer": [{text: 'Normal', value: ""}, {text: 'Prozent', value: "float_percent"}],
      "integer_negative": [{text: 'Normal', value: ""}, {text: 'Prozent', value: "float_percent"}],
      "date": ["DD.MM.YYYY", "DD.MM.YY", "DD.MM.YY", "MM.YYYY", "DD", "MM", "YYYY", "YY"],
    },
    tasks: [],
    showTestDialog: false,
    selectedTask: null,
    taskSearch: "",

  }),
  mounted() {
    this.initSortable();
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/invoice_definition/' + this.$route.params.id
    ).then(this.responseOkFetch, this.responseError)
  },
  computed: {
    filteredTask() {
      return this.tasks.filter((el) => {
        return el.object.toLowerCase().includes(this.taskSearch.toLowerCase()) || el.aufisn.toLowerCase().includes(this.taskSearch.toLowerCase())
      });
    }
  },
  methods: {
    generateTestFile(taskId) {
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/invoice_definition_test/'+taskId,
          {
            definition: this.definition,
            entries: this.entries
          }
      ).then((response) => {
        this.hideLoader()
        let filename = 'downloaded_file.txt';
        const disposition = response.headers.get('Content-Disposition');
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) {
            // Remove potential surrounding quotes from the filename
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // 3. Create a blob URL from the response body
        const blob = new Blob([response.body]);
        const downloadUrl = window.URL.createObjectURL(blob);

        // 4. Create a hidden link and click it to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename); // Set the filename

        // Append to body, click, and clean up
        document.body.appendChild(link);
        link.click();

        // 5. Cleanup the DOM and release the object URL memory
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, this.responseError)
    },
    getTestData() {
      if (this.tasks.length) {
        this.showTestDialog = true;
        return
      }
      this.showLoader();
      this.$http.get(
          Server_URL + '/auftragsbuch/invoice_definition_test'
      ).then((response) => {
        if (response.status === 200) {
          this.tasks = response.body;
          this.hideLoader();
          this.showTestDialog = true;
        } else {
          this.hideLoader();
          window.location = Redirect_500;
        }
      }, this.responseError)
    },
    onSave() {
      this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/invoice_definition/' + this.$route.params.id,
          {
            definition: this.definition,
            entries: this.entries
          }
      ).then((r) => {
        this.hideLoader();
        this.$bvToast.toast("Die Schnittstellendefinition wurde gespeichert und ist nun aktiv.", {
          title: 'Gespeichert',
          autoHideDelay: 5000,
          appendToast: false,
          toaster: 'b-toaster-top-center',
        });
        this.$router.go(-1);
      }, this.responseError)
    },
    onDelete() {
      this.showLoader();
      this.$http.delete(
          Server_URL + '/auftragsbuch/invoice_definition/' + this.$route.params.id
      ).then((r) => {this.hideLoader(); this.$router.go(-1)}, this.responseError)
    },
    initSortable() {
      // 1. Wait for the DOM to be fully rendered
      this.$nextTick(() => {
        // 2. Find the table body inside our specific table
        const tbody = document.querySelector(".sortable-table tbody");

        if (tbody) {
          // 3. Initialize Sortable
          Sortable.create(tbody, {
            handle: ".drag-handle", // Only allows dragging by the icon
            animation: 150,         // Smooth animation
            ghostClass: "ghost",    // Class applied to the dragged item

            // 4. Update the Vue array when dragging ends
            onEnd: (evt) => {
              const { oldIndex, newIndex, item } = evt;

              // 1. If the item wasn't moved, do nothing
              if (oldIndex === newIndex) return;

              // 2. Undo the DOM mutation made by Sortable.js
              // This puts the row back where it was so Vue's Virtual DOM doesn't get confused
              const parent = item.parentNode;
              const sibling = oldIndex < newIndex ? parent.children[oldIndex] : parent.children[oldIndex + 1];
              parent.insertBefore(item, sibling || null);

              // 3. Now update the Vue array. Vue's reactivity will naturally update the DOM cleanly.
              const movedItem = this.entries.splice(oldIndex, 1)[0];
              this.entries.splice(newIndex, 0, movedItem);
            }
          });
        }
      });
    },
    contentToText(entry) {
      let content = entry.content;
      if (entry.data_type !== "fixed" && entry.data_type !== "boolean" && entry.data_type !== "") {
        let cType = this.contentTypes[entry.data_type];
        for (let i = 0; i < cType.length; i++) {
          if (cType[i].value === content) {
            content = cType[i].text;
            break;
          }
        }
      }
      return content;
    },
    dataTypeToText(dataType) {
      for (let i = 0; i < this.dataTypes.length; i++) {
        if (this.dataTypes[i].value === dataType) {
          return this.dataTypes[i].text;
        }
      }
      return dataType;
    },
    formatToText(entry) {
      let format = entry.format;
      if (entry.data_type === "float" || entry.data_type === "float_negative" || entry.data_type === "integer" || entry.data_type === "integer_negative") {
        let dEntry = this.formats[entry.data_type];
        for (let i = 0; i < dEntry.length; i++) {
          if (dEntry[i].value === format) {
            format = dEntry[i].text;
            break;
          }
        }
      }
      return format;
    },
    entryToText(entry, defaultValue) {
      entry = entry.defaults[defaultValue];
      if(!entry) {
        return "nicht Überschreiben";
      }
      let content = entry.content;
      if (entry.data_type !== "fixed") {
        let cType = this.contentTypes[entry.data_type];
        for (let i = 0; i < cType.length; i++) {
          if (cType[i].value === content) {
            content = cType[i].text;
            break;
          }
        }
      }
      let dataType = "";
      for (let i = 0; i < this.dataTypes.length; i++) {
        if (this.dataTypes[i].value === entry.data_type) {
          dataType = this.dataTypes[i].text;
          break;
        }
      }
      let format = entry.format;
      if (entry.data_type === "float" || entry.data_type === "float_negative" || entry.data_type === "integer" || entry.data_type === "integer_negative") {
        let dEntry = this.formats[entry.data_type];
        for (let i = 0; i < dEntry.length; i++) {
          if (dEntry[i].value === format) {
            format = dEntry[i].text;
            break;
          }
        }
      }
      return dataType + ": " + content + (format !== "" ? " (" + format + ")" : "")
    },
    changeEntry(entry, subEntries) {
      console.log(entry)
      console.log(subEntries)
      if(this.currentEntry === undefined && entry === undefined) {
        // do nothing
        return;
      }
      if(this.currentEntry !== undefined && entry === undefined) {
        // remove current Entry
        this.deleteEntry(this.currentEntry);
        return;
      }
      if (entry.id === "new") {
        // give new id
        entry.id = v4();
        this.entries.push({
          entry: entry,
          defaults: subEntries,
        });
      } else {
        for (let i = 0; i < this.entries.length; i++) {
          if (this.entries[i].entry.id === entry.id) {
            this.entries[i] = {
              entry: entry,
              defaults: subEntries,
            };
          }
        }
      }
      this.currentEntry = undefined;
      this.currentDefaults = undefined;
      this.entries = [...this.entries]
    },
    editEntry(currentEntry) {
      this.currentEntry = currentEntry.entry;
      this.currentDefaults = currentEntry.defaults;
      this.$nextTick(() => {
        this.$refs['entry-dialog'].show();
      });
    },
    deleteEntry(entry) {
      for (let i = 0; i < this.entries.length; i++) {
        if (this.entries[i].entry.id === entry.id) {
          this.entries.splice(i, 1);
          break;
        }
      }
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkFetch(response) {
      if (response.status === 200) {
        let data = response.body;
        this.hideLoader();
        this.definition = data.definition.definition;
        this.entries = data.definition.entries;
        this.konto_settings = data.konto;
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    changeDefinition(def) {
      this.definition = {...def};
    }
  }
}
</script>

<style scoped>

.ghost {
  opacity: 0.5;
  background-color: #f0f0f0;
}
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}

.t-btn {
  height: 32px !important;
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  margin: auto 12px auto 0px;
}

.t-btn-left {
  margin: auto 12px auto auto !important;
}


::v-deep label {
  margin-bottom: initial;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .jexcel_content {
  height: calc(100vh - 55px - 2.55rem - 24px);
}

::v-deep .jexcel_container {
  height: calc(100vh - 55px - 2.55rem - 15px);
}

</style>
